import { MutationTree } from 'vuex';
import { LoginFailureRecordState, LoginFailureRecord } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: LoginFailureRecordState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorTitle = undefined;
    csvState.errorDetails = undefined;
};

export const mutations: MutationTree<LoginFailureRecordState> = {
    // ログイン失敗履歴の一覧取得系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; login_failure_records: Array<LoginFailureRecord> }) {
        state.loginFailureRecordCount = payload.count;
        state.loginFailureRecords = payload.login_failure_records;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetErrors(state);
        const csvState = state.csv;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const csvState = state.csv;
        csvState.errorTitle = payload.errorTitle;
        csvState.errorDetails = payload.errorDetails;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.loginFailureRecords = undefined;
        state.loginFailureRecordCount = 0;
    },
};
